<script>
import CamelraceCard from './CamelraceCard.vue'

export default {
    name: 'CamelTurnIndicator',
    components: {
        CamelraceCard,
    },
    props: {
        profile: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isVisible: false,
            hideTimeout: null,
        }
    },
    watch: {
        profile(newProfile, oldProfile) {
            if (!newProfile || !oldProfile) return
            if (newProfile.id !== oldProfile.id) {
                this.showIndicator()
            }
        },
    },
    beforeUnmount() {
        clearTimeout(this.hideTimeout)
    },
    mounted() {
        this.showIndicator()
    },
    methods: {
        showIndicator() {
            this.isVisible = true
            clearTimeout(this.hideTimeout)
            this.hideTimeout = setTimeout(() => {
                this.isVisible = false
            }, 5000)
        },
    },
}
</script>

<template>
    <Transition name="turnIndicator">
        <div
            v-if="isVisible"
            class="bgGradient absolute top-0 z-3 flex w-full flex-col items-center p-5"
        >
            <div
                class="font-title z-4 rounded-xs bg-[#E50328] px-6 py-2 text-xs font-black uppercase lg:text-lg"
            >
                {{ $t('play.your_turn') }}
            </div>
            <CamelraceCard color="#E50328" class="h-11 w-66 lg:h-16 lg:w-96">
                <div
                    class="w-full- playerText h-full text-center text-lg leading-11 font-black uppercase lg:text-2xl lg:leading-16"
                >
                    {{ profile.tag_name }}
                </div>
            </CamelraceCard>
        </div>
    </Transition>
</template>

<style lang="scss">
.bgGradient {
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 200%;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.75) 0%, rgba(0, 0, 0, 0) 100%);
    }
}

.playerText {
    text-shadow:
        -1px -1px 0 #000,
        1px -1px 0 #000,
        -1px 1px 0 #000,
        1px 1px 0 #000,
        3px 2px 0 #000;
}

.turnIndicator-enter-active,
.turnIndicator-leave-active {
    transition: 0.3s ease;
}

.turnIndicator-enter-from,
.turnIndicator-leave-to {
    opacity: 0;
    transform: translateY(-10px);
}
</style>
